import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
`;

export const VerticalContainer = styled.div`
  position: absolute;
  top: 50%;
  right: -120px;
  transform: rotate(-90deg);

  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;

export const VerticalContent = styled.div`
  h1 {
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    /* identical to box height */

    letter-spacing: 0.2em;

    color: #272727;
  }

  div {
    position: absolute;
    width: 45px;
    height: 0.5px;
    top: 6px;
    left: -55px;

    background-color: #272727;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  margin: 0 auto;
  margin-top: 100px;

  max-width: 1200px;
  height: 700px;

  padding: 20px;

  @media only screen and (max-width: 1000px) {
    flex-direction: column-reverse;

    margin-top: 15px;

    height: auto;
  }
`;

// ---> Start Image Content <---
export const ImageContent = styled.div`
  position: relative;
  width: 490px;
  display: flex;
  justify-content: center;

  img {
    filter: drop-shadow(6px 7px 6px rgba(0, 0, 0, 0.28));
  }

  @media only screen and (max-width: 1000px) {
    width: auto;
    margin-top: 50px;
    margin-bottom: 70px;
  }
`;

export const ImageOne = styled.img`
  z-index: 2;

  width: 287px;
  height: 415px;

  @media only screen and (max-width: 1300px) {
    transform: translate(5vw, 0px);
  }

  @media only screen and (max-width: 1000px) {
    width: min(45vw, 287px);
    height: min(63vw, 415px);

    transform: translate(5vw, 0px);
  }
`;

export const ImageTwo = styled.img`
  z-index: 1;
  transform: translate(-100px, 200px);

  width: 355px;
  height: 393px;

  @media only screen and (max-width: 1000px) {
    width: min(45vw, 355px);
    height: min(50vw, 393px);

    transform: translate(-5vw, 15vh);
  }
`;
// ---> End Image Content <---

// ---> Start Content <---
export const ContentContainer = styled.div`
  position: relative;

  display: flex;
  flex: 1;
  justify-content: center;
`;

export const ContentInfos = styled.div`
  margin-top: 35px;
  padding-left: 85px;

  h1 {
    font-weight: 900;
    font-size: 40px;
    line-height: 60px;

    color: #7d7d7d;
  }

  p {
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    text-align: justify;

    margin-top: 20px;
    max-width: 450px;

    color: #000000;
  }

  @media only screen and (max-width: 1000px) {
    margin-top: 0px;
    padding-left: 0px;

    text-align: center;

    h1 {
      font-size: min(7.5vw, 40px);
      line-height: min(10vw, 60px);
    }

    p {
      font-size: min(4vw, 15px);
      line-height: min(5vw, 22px);
    }
  }
`;
// ---> End Content <---

export const LearnMore = styled.div`
  margin-top: 20px;

  a {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    text-decoration: none;
    transition: color 0.2s;

    color: #272727;

    :hover {
      color: #386882;
    }
  }

  @media only screen and (max-width: 1000px) {
    a {
      font-size: min(4.5vw, 18px);
    }
  }
`;

export const BlueBackground = styled.div`
  z-index: -1;
  position: absolute;
  left: 0;

  background-color: #ffffff;

  top: 25px;

  width: 100vw;
  height: 335px;

  transform: translate(-15px, 0px);

  div {
    position: absolute;
    top: 0;
    left: 15px;

    h1 {
      font-weight: bold;
      font-size: 50px;
      line-height: 75px;

      color: #272727;
    }
  }

  @media only screen and (max-width: 1000px) {
    div {
      display: none;
    }
  }
`;

export const BlueRectangle = styled.div`
  position: absolute;
  z-index: -1;

  width: 130vw;
  height: 360px;
  top: 0;

  background-color: #199ec6;

  transform-origin: 2% -30%;
  transform: rotate(25.26deg);

  @media only screen and (max-width: 1000px) {
    display: none;
  }

  @media only screen and (min-width: 1800px) {
    transform-origin: 14% -30%;
  }

  @media only screen and (min-width: 3840px) {
    transform-origin: 24% -70%;
  }
`;

export const BlueRectangleMobile = styled.div`
  display: none;
  position: absolute;

  z-index: 0;

  width: 180vw;
  height: 100%;

  top: -20vmin;
  left: -15vw;

  background-color: #199ec6;
  transform-origin: 0 0;
  transform: rotate(25.26deg);

  @media only screen and (max-width: 1000px) {
    display: block;
  }
`;
